exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.txt-news-content[data-v-bab51a40] {\n  display: flow-root;\n}\n.txt-news-list-file[data-v-bab51a40] {\n  display: grid;\n}\n.txt-news-list-file a[data-v-bab51a40] {\n  word-wrap: break-word;\n  display: inline-flex;\n  margin-bottom: 10px;\n  background-size: 24px 26px;\n  padding-left: 30px ;\n  color: black;\n}\n.txt-news-list-file a[data-v-bab51a40]:hover {\n  color: black;\n}\n", ""]);

// exports
